import { IncError } from "@core/domain/errors/inc.error";
import i18n from "@i18n";

export class BeneficiaryMapperError extends IncError {
    constructor() {
        super(i18n.t("error:beneficiary.mapperError"));

        Object.setPrototypeOf(this, BeneficiaryMapperError.prototype);
    }
}